import { render, staticRenderFns } from "./AttestatoFinaleTirEstivoReview.vue?vue&type=template&id=3006eeba&scoped=true&"
import script from "./AttestatoFinaleTirEstivoReview.vue?vue&type=script&lang=ts&"
export * from "./AttestatoFinaleTirEstivoReview.vue?vue&type=script&lang=ts&"
import style0 from "./AttestatoFinaleTirEstivoReview.vue?vue&type=style&index=0&id=3006eeba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3006eeba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VRow})
